import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { ApiDatatableResponse } from 'src/app/main/_models/api-datatable-response';

@Injectable({
	providedIn: 'root'
})
export class PricelistService {

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }

	get(id: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/pricelists` + (id ? "/" + id : ""));
	}

	datatable(f: any) {
		return this.http.post<ApiDatatableResponse>(`${this.config.getConfig("apiEndpoint")}/pricelists/dt`, f);
	}

	delete(id: number) {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/pricelists/` + id);
	}

	upsert(v: PostDataPricelist) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/pricelists`, v);
	}
}

export interface PostDataPricelistTableImporti {
	[key: string]: number;
}

export interface PostDataPricelistTableVeicoli {
	[key: string]: PostDataPricelistTableImporti;
}

export interface PostDataPricelistPenale {
	"penaleValore"?: number;
	"penaleTipoValore"?: string;
	"penaleEntro"?: number;
}

export interface PostDataPricelistPenali {
	"lista"?: Array<PostDataPricelistPenale>;
}

export interface PostDataPricelistTransferDefinizioni {
	"importoMin"?: number;
	"maxKm"?: number;
}

export interface PostDataPricelistDispoDefinizioni {
	"kmInclusi"?: number;
	"maxHr"?: number;
}

export interface PostDataPricelistPoi {
	"id"?: number;
	"formatted_address"?: string;
	"type"?: string;
	"lat"?: number;
	"lng"?: number;
}

export interface PostDataPricelistPolyPoint {
	"lat": number;
	"lng": number;
}

export interface PostDataPricelistPoly {
	"id"?: number;
	"nome"?: string;
	"points"?: Array<PostDataPricelistPolyPoint>;
}

export interface PostDataPricelistTratteDefinizioni {
	"nome"?: string;
	"id"?: number;
	"partenzaPoi"?: PostDataPricelistPoi;
	"arrivoPoi"?: PostDataPricelistPoi;
	"partenzaPoly"?: PostDataPricelistPoly;
	"arrivoPoly"?: PostDataPricelistPoly;
}

export interface PostDataPricelistTransfer {
	"chkTipoTrasferimento"?: string;
	"tabellaVeicoliTrasferimento"?: PostDataPricelistTableVeicoli;
	"tabellaVeicoliTrasferimento2"?: PostDataPricelistTableVeicoli;
	"penali"?: PostDataPricelistPenali;
	"definizioni"?: Array<PostDataPricelistTransferDefinizioni>;
}

export interface PostDataPricelistDispo {
	"tabellaVeicoli"?: PostDataPricelistTableVeicoli;
	"penali"?: PostDataPricelistPenali;
	"definizioni"?: Array<PostDataPricelistDispoDefinizioni>;
}

export interface PostDataPricelistTratte {
	"tabellaVeicoli"?: PostDataPricelistTableVeicoli;
	"penali"?: PostDataPricelistPenali;
	"definizioni"?: Array<PostDataPricelistTratteDefinizioni>;
}

export interface PostDataPricelistExtra {
	"txtNotturno"?: number;
	"txtFestivo"?: number;
	"txtPranzoAutista"?: number;
	"selPranzoAutistaOgniQuanto"?: number;
	"selNotturnoDa"?: number;
	"selNotturnoA"?: number;
}

export interface PostDataPricelist {
	"id"?: number;
	"txtNome"?: string
	"txtDescrizione"?: string;
	"selAssociatoA"?: number;
	"transfer"?: PostDataPricelistTransfer;
	"dispoIn"?: PostDataPricelistDispo;
	"dispoFuori"?: PostDataPricelistDispo;
	"tratte"?: PostDataPricelistTratte;
	"extra"?: PostDataPricelistExtra;
	"penali"?: PostDataPricelistPenali;
}
